(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Sections live in groups/JSON templates, so their IDs are generated
    // (e.g. "template--123__main"). Read them from the DOM; requesting the bare
    // names "main"/"header" returns nothing or renders default settings.
    const sectionIdOf = (el, fallback) =>
      el?.closest('.shopify-section')?.id.replace('shopify-section-', '') || fallback;
    const getCartSectionIds = () => ({
      mainSectionId: sectionIdOf(document.querySelector('.cart-page'), 'main'),
      headerSectionId: sectionIdOf(document.querySelector('header'), 'header'),
    });

    // --- Dynamic Delivery Date for Standalone Cart Page ---
    const updateDeliveryDate = () => {
      const el = document.querySelector('.js-cart-page-delivery-date');
      if (!el) return;

      const minDays = parseInt(el.dataset.minDays || '2', 10);
      const maxDays = parseInt(el.dataset.maxDays || '5', 10);

      const addWorkdays = (startDate, numDays) => {
        let date = new Date(startDate);
        let added = 0;
        while (added < numDays) {
          date.setDate(date.getDate() + 1);
          const day = date.getDay();
          const isWeekend = (day === 0 || day === 6);
          if (!isWeekend && !isGermanHoliday(date)) {
            added++;
          }
        }
        return date;
      };

      const isGermanHoliday = (date) => {
        const m = date.getMonth();
        const d = date.getDate();
        if (m === 0 && d === 1) return true;
        if (m === 4 && d === 1) return true;
        if (m === 9 && d === 3) return true;
        if (m === 11 && d === 25) return true;
        if (m === 11 && d === 26) return true;

        const y = date.getFullYear();
        const easter = getEasterSunday(y);
        const timeDiff = date.getTime() - easter.getTime();
        const daysDiff = Math.round(timeDiff / (1000 * 60 * 60 * 24));
        if (daysDiff === -2) return true;
        if (daysDiff === 1) return true;
        if (daysDiff === 39) return true;
        if (daysDiff === 50) return true;
        return false;
      };

      const getEasterSunday = (year) => {
        const f = Math.floor,
              G = year % 19,
              C = f(year / 100),
              H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
              I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
              J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
              L = I - J,
              month = 3 + f((L + 40) / 44),
              day = L + 28 - 31 * f(month / 4);
        return new Date(Date.UTC(year, month - 1, day));
      };

      const formatDate = (date) => {
        const weekdays = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
        const deMonths = [
          'Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 
          'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'
        ];
        return `${weekdays[date.getDay()]} ${date.getDate()}. ${deMonths[date.getMonth()]}`;
      };

      const today = new Date();
      const minDate = addWorkdays(today, minDays);
      const maxDate = addWorkdays(today, maxDays);

      const templateText = el.textContent;
      const placeholder = '...';
      const formattedRange = `${formatDate(minDate)} - ${formatDate(maxDate)}`;
      
      if (templateText.includes(placeholder)) {
        el.innerHTML = templateText.replace(placeholder, formattedRange);
      } else {
        const prefix = templateText.split(':')[0] || 'Lieferung ca.';
        el.innerHTML = `${prefix}: ${formattedRange}`;
      }
    };

    // --- Checkout Form validation ---
    const initCheckoutValidation = () => {
      const checkoutForm = document.querySelector('.cart-page__checkout-form');
      if (!checkoutForm) return;

      checkoutForm.addEventListener('submit', (event) => {
        if (checkoutForm.dataset.validated === 'true') {
          return; // Let form submit normally
        }

        event.preventDefault();
        const checkoutBtn = checkoutForm.querySelector('.cart-page__checkout-btn');
        if (!checkoutBtn || checkoutBtn.disabled) return;

        // Set button loading state
        checkoutBtn.disabled = true;
        checkoutBtn.setAttribute('aria-disabled', 'true');
        const loadingText = checkoutBtn.dataset.loadingText || 'Verfügbarkeit wird geprüft...';
        checkoutBtn.innerHTML = `<svg class="cart-btn-spinner" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg> <span>${loadingText}</span>`;

        // Fetch fresh main and header HTML to check availability
        const { mainSectionId, headerSectionId } = getCartSectionIds();
        fetch(`/cart?sections=${mainSectionId},${headerSectionId}`)
          .then(res => {
            if (!res.ok) throw new Error('Fetch failed');
            return res.json();
          })
          .then(sectionsData => {
            const mainHTML = sectionsData[mainSectionId];
            const headerHTML = sectionsData[headerSectionId];
            if (!mainHTML) throw new Error('No main markup returned');

            const parser = new DOMParser();
            const docMain = parser.parseFromString(mainHTML, 'text/html');
            
            // Check if there are any sold out items in the fresh HTML
            const hasSoldOut = docMain.querySelector('.cart-page-item.is-sold-out') !== null;

            if (hasSoldOut) {
              // Update cart page DOM
              const newCartPage = docMain.querySelector('.cart-page');
              const oldCartPage = document.querySelector('.cart-page');
              if (newCartPage && oldCartPage) {
                oldCartPage.innerHTML = newCartPage.innerHTML;
              }

              // Update header & drawer DOM if headerHTML is available
              if (headerHTML) {
                const docHeader = parser.parseFromString(headerHTML, 'text/html');
                const newHeader = docHeader.querySelector('header');
                const oldHeader = document.querySelector('header');
                if (newHeader && oldHeader) {
                  oldHeader.innerHTML = newHeader.innerHTML;
                }

                const newDialog = docHeader.querySelector('#cart-drawer-dialog');
                const oldDialog = document.getElementById('cart-drawer-dialog');
                if (newDialog && oldDialog) {
                  oldDialog.innerHTML = newDialog.innerHTML;
                }
              }

              document.dispatchEvent(new CustomEvent('cart:updated'));
            } else {
              // Validation passed, submit form to proceed to checkout
              checkoutForm.dataset.validated = 'true';
              checkoutForm.submit();
            }
          })
          .catch(err => {
            console.error('Error verifying cart availability before checkout:', err);
            // Fallback: Proceed to checkout if network fails
            checkoutForm.dataset.validated = 'true';
            checkoutForm.submit();
          });
      });
    };

    const initClearSoldPage = () => {
      const clearBtn = document.querySelector('.js-clear-sold-page');
      if (!clearBtn) return;
      clearBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const soldItems = document.querySelectorAll('.cart-page-item.is-sold-out');
        const updates = {};
        soldItems.forEach(item => {
          const key = item.getAttribute('data-line-item-key');
          if (key) updates[key] = 0;
        });

        if (Object.keys(updates).length === 0) return;

        clearBtn.disabled = true;
        clearBtn.style.opacity = '0.5';

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        })
        .then(res => {
          if (!res.ok) throw new Error('Failed to update cart');
          return res.json();
        })
        .then(() => {
          window.location.reload();
        })
        .catch(err => {
          console.error('Error clearing sold items from cart page:', err);
          clearBtn.disabled = false;
          clearBtn.style.opacity = '';
        });
      });
    };

    initClearSoldPage();

    document.addEventListener('cart:updated', () => {
      updateDeliveryDate();
      initCheckoutValidation();
      initClearSoldPage();
    });

    const refreshCartPageAndHeader = () => {
      const checkoutForm = document.querySelector('.cart-page__checkout-form');
      const checkoutBtn = checkoutForm?.querySelector('.cart-page__checkout-btn');
      const isCurrentlyLoading = checkoutBtn && checkoutBtn.disabled && checkoutBtn.querySelector('.cart-btn-spinner');
      if (isCurrentlyLoading) return;

      const { mainSectionId, headerSectionId } = getCartSectionIds();
      fetch(`/cart?sections=${mainSectionId},${headerSectionId}`)
        .then(res => res.json())
        .then(sectionsData => {
          const mainHTML = sectionsData[mainSectionId];
          const headerHTML = sectionsData[headerSectionId];
          const parser = new DOMParser();

          if (mainHTML) {
            const docMain = parser.parseFromString(mainHTML, 'text/html');
            const newCartPage = docMain.querySelector('.cart-page');
            const oldCartPage = document.querySelector('.cart-page');
            if (newCartPage && oldCartPage) {
              oldCartPage.innerHTML = newCartPage.innerHTML;
            }
          }

          if (headerHTML) {
            const docHeader = parser.parseFromString(headerHTML, 'text/html');
            const newHeader = docHeader.querySelector('header');
            const oldHeader = document.querySelector('header');
            if (newHeader && oldHeader) {
              oldHeader.innerHTML = newHeader.innerHTML;
            }
            const newDialog = docHeader.querySelector('#cart-drawer-dialog');
            const oldDialog = document.getElementById('cart-drawer-dialog');
            if (newDialog && oldDialog) {
              oldDialog.innerHTML = newDialog.innerHTML;
            }
          }

          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(err => console.error('Error refreshing cart page:', err));
    };

    updateDeliveryDate();
    initCheckoutValidation();

    // Reset checkout button loading state on pageshow (e.g., back button from checkout)
    window.addEventListener('pageshow', (event) => {
      const checkoutForm = document.querySelector('.cart-page__checkout-form');
      const checkoutBtn = document.querySelector('.cart-page__checkout-btn');
      if (checkoutForm && checkoutBtn) {
        checkoutForm.removeAttribute('data-validated');
        
        if (checkoutBtn.disabled && checkoutBtn.getAttribute('aria-disabled') === 'true' && checkoutBtn.querySelector('.cart-btn-spinner')) {
          checkoutBtn.disabled = false;
          checkoutBtn.removeAttribute('aria-disabled');
          if (checkoutBtn.dataset.originalText) {
            checkoutBtn.innerHTML = checkoutBtn.dataset.originalText;
          }
        }
      }

      // Refresh cart standalone page if restored from cache
      if (event.persisted) {
        refreshCartPageAndHeader();
      }
    });

    // Refresh cart standalone page when tab becomes visible
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        refreshCartPageAndHeader();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Center the active mobile chip inside the scroll container (Fallback for Safari/Firefox)
    if (!CSS.supports('scroll-initial-target', 'nearest')) {
      const centerActiveChip = () => {
        const activeMobileChip = document.querySelector('.collection-mobile-nav__chip.is-active');
        const scrollContainer = document.querySelector('.collection-mobile-nav__scroll-container');
        if (activeMobileChip && scrollContainer) {
          const containerRect = scrollContainer.getBoundingClientRect();
          const chipRect = activeMobileChip.getBoundingClientRect();
          const scrollOffset = (chipRect.left - containerRect.left) - (containerRect.width / 2) + (chipRect.width / 2);
          scrollContainer.scrollLeft += scrollOffset;
        }
      };

      centerActiveChip();
      // Recalculate on window load to account for custom fonts or image loading layout changes
      window.addEventListener('load', centerActiveChip);
    }

    // Detect active gender from current page state (either query params or SEO handle in path)
    let activeGender = null;
    const currentParams = new URLSearchParams(window.location.search);
    if (currentParams.has('filter.p.m.custom.target_gender')) {
      activeGender = currentParams.get('filter.p.m.custom.target_gender');
    } else {
      const pathParts = window.location.pathname.split('/').filter(Boolean);
      const handle = pathParts[pathParts.length - 1];
      if (handle) {
        const handleParts = handle.split('-');
        if (handleParts.length > 2) {
          if (handleParts[1] === 'jungen') {
            activeGender = 'Boy';
          } else if (handleParts[1] === 'maedchen') {
            activeGender = 'Girl';
          }
        }
      }
    }

    const navLinks = document.querySelectorAll('[data-collection-nav-link]');
    navLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        
        const targetUrlString = link.getAttribute('href');
        if (!targetUrlString) return;

        try {
          // Resolve full URL relative to location.origin
          const targetUrl = new URL(targetUrlString, window.location.origin);
          
          // Get current page query parameters
          const currentParams = new URLSearchParams(window.location.search);
          
          // Only preserve sorting and search terms on navigation to avoid retaining removed filters
          const paramsToPreserve = ['sort_by', 'q', 'type'];
          paramsToPreserve.forEach(key => {
            if (currentParams.has(key) && !targetUrl.searchParams.has(key)) {
              targetUrl.searchParams.set(key, currentParams.get(key));
            }
          });

          // If this is a category navigation link (not a filter action), preserve the active gender filter
          const isFilterLink = link.classList.contains('filter-group__header-reset') ||
                               link.classList.contains('active-filters__clear-all');
          const isCategoryLink = !isFilterLink;
          
          if (isCategoryLink && activeGender) {
            const targetPathParts = targetUrl.pathname.split('/').filter(Boolean);
            const targetHandle = targetPathParts[targetPathParts.length - 1];
            let targetHasGender = false;
            if (targetHandle) {
              const targetHandleParts = targetHandle.split('-');
              if (targetHandleParts.length > 2 && (targetHandleParts[1] === 'jungen' || targetHandleParts[1] === 'maedchen')) {
                targetHasGender = true;
              }
            }
            if (!targetHasGender && !targetUrl.searchParams.has('filter.p.m.custom.target_gender')) {
              targetUrl.searchParams.set('filter.p.m.custom.target_gender', activeGender);
            }
          }
          
          // Navigate to target URL with parameters preserved
          window.location.href = targetUrl.pathname + targetUrl.search + targetUrl.hash;
        } catch (e) {
          // Fallback to normal URL navigation
          window.location.href = targetUrlString;
        }
      });
    });

    // Filter form submission on choice
    const filterForm = document.getElementById('CollectionFiltersForm');
    if (filterForm) {
      filterForm.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(input => {
        input.addEventListener('change', () => {
          if (input.hasAttribute('data-seo-filter-checkbox') && !input.checked) {
            const baseUrlString = input.getAttribute('data-seo-filter-base-url');
            if (baseUrlString) {
              try {
                const targetUrl = new URL(baseUrlString, window.location.origin);
                targetUrl.searchParams.delete('filter.p.m.custom.target_gender');
                window.location.href = targetUrl.pathname + targetUrl.search + targetUrl.hash;
              } catch (e) {
                window.location.href = baseUrlString;
              }
              return;
            }
          }
          filterForm.submit();
        });
      });
    }

    // Close filter dropdowns when clicking outside
    document.addEventListener('click', (event) => {
      const details = document.querySelectorAll('details[data-filter-group]');
      details.forEach(detail => {
        if (!detail.contains(event.target)) {
          detail.removeAttribute('open');
        }
      });
    });

    // Close filter dropdowns when pressing Escape key (A11y enhancement)
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const details = document.querySelectorAll('details[data-filter-group]');
        details.forEach(detail => {
          detail.removeAttribute('open');
        });
      }
    });

    // Up to 1200px the filters sit in a swipeable row; their dropdowns are positioned
    // against the surrounding bar, so place them under their button (kept inside the bar)
    const filterList = document.querySelector('[data-filter-list]');
    const compactFilters = window.matchMedia('(max-width: 1200px)');
    const placeInFilterBar = (detail) => {
      const content = detail.querySelector('.filter-group__content');
      if (!content) return false;
      if (!filterList || !filterList.contains(detail) || !compactFilters.matches) {
        content.style.removeProperty('--filter-dropdown-left');
        return false;
      }
      const bar = filterList.parentElement.getBoundingClientRect();
      const summary = detail.querySelector('summary').getBoundingClientRect();
      const maxLeft = Math.max(0, bar.width - content.offsetWidth);
      const left = Math.min(Math.max(summary.left - bar.left, 0), maxLeft);
      content.classList.remove('filter-group__content--right');
      content.style.setProperty('--filter-dropdown-left', `${left}px`);
      return true;
    };

    filterList?.addEventListener('scroll', () => {
      const openDetail = filterList.querySelector('details[open]');
      if (openDetail) placeInFilterBar(openDetail);
    }, { passive: true });

    // Exclusive open for filter dropdowns (accordion style), and flip the panel
    // to the left when it would overflow the viewport's right edge.
    const details = document.querySelectorAll('details[data-filter-group]');
    details.forEach(targetDetail => {
      targetDetail.addEventListener('toggle', () => {
        if (targetDetail.open) {
          details.forEach(detail => {
            if (detail !== targetDetail && detail.open) {
              detail.removeAttribute('open');
            }
          });

          const content = targetDetail.querySelector('.filter-group__content');
          if (content && !placeInFilterBar(targetDetail)) {
            content.classList.remove('filter-group__content--right');
            if (content.getBoundingClientRect().right > window.innerWidth) {
              content.classList.add('filter-group__content--right');
            }
          }
        }
      });
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  // Loads Shopify product recommendations via the Section Rendering API once the
  // row comes near the viewport, then swaps in the server-rendered markup.
  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded || !this.dataset.url) return;
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        }, { rootMargin: '0px 0px 400px 0px' });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      load() {
        this.dataset.loaded = 'true';
        fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('product-recommendations');
            if (!fresh || !fresh.innerHTML.trim()) return;
            this.innerHTML = fresh.innerHTML;
            // Let product cards bind wishlist/cart handlers to the new markup
            document.dispatchEvent(new CustomEvent('product-cards:added'));
          })
          .catch((error) => console.error('Error loading recommendations:', error));
      }
    }

    customElements.define('product-recommendations', ProductRecommendations);
  }

  if (!customElements.get('featured-products-carousel')) {
    class FeaturedProductsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.controls = this.querySelector('[data-carousel-controls]');
        this.prevBtn = this.querySelector('[data-carousel-prev]');
        this.nextBtn = this.querySelector('[data-carousel-next]');
        if (!this.track || !this.controls || !this.prevBtn || !this.nextBtn) return;

        this.update = this.update.bind(this);
        this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
        this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
        this.track.addEventListener('scroll', this.update, { passive: true });

        // Re-evaluate overflow whenever the track or its cards change size
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();

        if (this.dataset.nextUrl) this.observeEnd();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.endObserver?.disconnect();
      }

      // Endless loading: when the last card comes within half a view of the
      // visible area, fetch the next pagination page and append its cards.
      observeEnd() {
        this.endObserver ??= new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
        }, { root: this.track, rootMargin: '0px 50% 0px 0px' });
        this.endObserver.disconnect();
        const cards = this.track.querySelectorAll('.collection-product');
        if (cards.length) this.endObserver.observe(cards[cards.length - 1]);
      }

      async loadMore() {
        const url = this.dataset.nextUrl;
        if (!url || this.loading) return;
        this.loading = true;
        this.track.setAttribute('aria-busy', 'true');

        try {
          const requestUrl = new URL(url, window.location.origin);
          requestUrl.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(requestUrl);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fresh = doc.querySelector('featured-products-carousel');
          const newCards = fresh?.querySelectorAll('[data-carousel-track] > .collection-product:not(.featured-products__placeholder)') ?? [];
          this.track.append(...newCards);
          this.dataset.nextUrl = fresh?.dataset.nextUrl ?? '';

          if (newCards.length) document.dispatchEvent(new CustomEvent('product-cards:added'));
          this.update();
        } catch (error) {
          // Stop instead of retrying endlessly; the cards already shown stay usable
          console.error('Error loading more products:', error);
          this.dataset.nextUrl = '';
        } finally {
          this.loading = false;
          this.track.removeAttribute('aria-busy');
        }

        // A page may contain only sold-out items; observing the (new) last card re-fires
        // right away while the end is still in range
        if (this.dataset.nextUrl) this.observeEnd();
        else this.endObserver?.disconnect();
      }

      scrollByCard(direction) {
        const card = this.track.querySelector('.collection-product');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = (card?.offsetWidth || 300) + gap;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * step, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const hasOverflow = scrollWidth > clientWidth + 4;
        this.controls.hidden = !hasOverflow;
        if (!hasOverflow) return;

        this.prevBtn.disabled = scrollLeft <= 5;
        this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 5;
      }
    }

    customElements.define('featured-products-carousel', FeaturedProductsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  {
    const button = document.querySelector('[data-cookie-preferences]');
    // Shopify's cookie banner exposes window.privacyBanner once loaded (only if the banner is enabled)
    const reveal = () => {
      if (button && window.privacyBanner?.showPreferences) button.hidden = false;
    };
    reveal();
    document.addEventListener('DOMContentLoaded', reveal);
    window.addEventListener('load', reveal);
    button?.addEventListener('click', () => window.privacyBanner?.showPreferences());
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popular-categories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const track = document.querySelector('.js-popular-categories-track');
    const controls = document.querySelector('.js-popular-controls');
    const prevBtn = document.querySelector('.js-popular-prev');
    const nextBtn = document.querySelector('.js-popular-next');

    if (track && controls && prevBtn && nextBtn) {
      const updateControls = () => {
        const hasOverflow = track.scrollWidth > track.clientWidth + 4;
        controls.style.display = hasOverflow ? 'flex' : 'none';

        if (hasOverflow) {
          const atStart = track.scrollLeft <= 5;
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
          prevBtn.disabled = atStart;
          nextBtn.disabled = atEnd;
          prevBtn.style.opacity = atStart ? '0.3' : '1';
          prevBtn.style.cursor = atStart ? 'default' : 'pointer';
          nextBtn.style.opacity = atEnd ? '0.3' : '1';
          nextBtn.style.cursor = atEnd ? 'default' : 'pointer';
        }
      };

      prevBtn.addEventListener('click', () => {
        const cardWidth = track.querySelector('.popular-categories__card')?.offsetWidth || 260;
        track.scrollBy({ left: -(cardWidth + 16), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        const cardWidth = track.querySelector('.popular-categories__card')?.offsetWidth || 260;
        track.scrollBy({ left: cardWidth + 16, behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
      setTimeout(updateControls, 100);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-back-link')) {
    class ProductBackLink extends HTMLElement {
      connectedCallback() {
        const link = this.querySelector('[data-back-link]');
        const label = this.querySelector('[data-back-label]');
        const previous = window.previousShopPage;
        if (!link || !label || !previous || !previous.url || !previous.label) return;

        // Only when the visitor really came from that page in this shop (not from another
        // tab). A reload may report the page itself as referrer; the stored previous page
        // is kept for reloads, so it still applies.
        let cameFromPrevious = false;
        try {
          const navigation = performance.getEntriesByType('navigation')[0];
          const referrer = document.referrer ? new URL(document.referrer) : null;
          cameFromPrevious = (navigation && navigation.type === 'reload') ||
            (Boolean(referrer) && referrer.origin === location.origin &&
              referrer.pathname + referrer.search === previous.url);
        } catch (error) {}
        if (!cameFromPrevious) return;

        link.href = previous.url;
        label.textContent = previous.label;
        link.addEventListener('click', (event) => {
          if (history.length > 1) {
            event.preventDefault();
            history.back();
          }
        });
      }
    }
    customElements.define('product-back-link', ProductBackLink);
  }

  if (!customElements.get('product-delivery-calculator')) {
    class ProductDeliveryCalculator extends HTMLElement {
      connectedCallback() {
        const minDays = parseInt(this.dataset.minDays || '2', 10);
        const maxDays = parseInt(this.dataset.maxDays || '5', 10);
        
        const today = new Date();
        const minDate = this.addWorkdays(today, minDays);
        const maxDate = this.addWorkdays(today, maxDays);
        
        const displayElement = this.querySelector('.js-delivery-date-range');
        if (displayElement) {
          displayElement.textContent = `${this.formatDate(minDate)} - ${this.formatDate(maxDate)}`;
          this.style.display = 'flex';
        }
      }

      formatDate(date) {
        const weekdays = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
        const months = ['Mai', 'Mai', 'Mai', 'Mai', 'Mai', 'Mai', 'Mai', 'Mai', 'Mai', 'Mai', 'Mai', 'Mai']; // Default safety fallback
        
        // Proper German Month Names
        const deMonths = [
          'Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 
          'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'
        ];
        
        const wd = weekdays[date.getDay()];
        const d = date.getDate();
        const m = deMonths[date.getMonth()];
        
        return `${wd} ${d}. ${m}`;
      }

      addWorkdays(startDate, numDays) {
        let date = new Date(startDate);
        let added = 0;
        while (added < numDays) {
          date.setDate(date.getDate() + 1);
          const day = date.getDay();
          const isWeekend = (day === 0 || day === 6);
          if (!isWeekend && !this.isGermanHoliday(date)) {
            added++;
          }
        }
        return date;
      }

      isGermanHoliday(date) {
        const y = date.getFullYear();
        const m = date.getMonth(); // 0-indexed
        const d = date.getDate();

        // 1. Fixed German national public holidays
        if (m === 0 && d === 1) return true; // Jan 1: Neujahrstag
        if (m === 4 && d === 1) return true; // May 1: Tag der Arbeit
        if (m === 9 && d === 3) return true; // Oct 3: Tag der Deutschen Einheit
        if (m === 11 && d === 25) return true; // Dec 25: 1. Weihnachtstag
        if (m === 11 && d === 26) return true; // Dec 26: 2. Weihnachtstag

        // 2. Dynamic holidays (Easter-related)
        const easter = this.getEasterSunday(y);
        const timeDiff = date.getTime() - easter.getTime();
        const daysDiff = Math.round(timeDiff / (1000 * 60 * 60 * 24));

        if (daysDiff === -2) return true; // Karfreitag
        if (daysDiff === 1) return true;  // Ostermontag
        if (daysDiff === 39) return true; // Christi Himmelfahrt
        if (daysDiff === 50) return true; // Pfingstmontag

        return false;
      }

      getEasterSunday(year) {
        const f = Math.floor,
              G = year % 19,
              C = f(year / 100),
              H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
              I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
              J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
              L = I - J,
              month = 3 + f((L + 40) / 44),
              day = L + 28 - 31 * f(month / 4);
        return new Date(Date.UTC(year, month - 1, day));
      }
    }
    customElements.define('product-delivery-calculator', ProductDeliveryCalculator);
  }

  if (!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        
        // Wait for child elements to be parsed by the browser
        setTimeout(() => {
          if (this.initialized) return;
          this.initGallery();
        }, 0);
      }

      initGallery() {
        this.slidesContainer = this.querySelector('.product-gallery__slides');
        this.slides = this.querySelectorAll('.product-gallery__slide');
        this.thumbnails = this.querySelectorAll('.product-gallery__thumbnail');
        this.prevBtn = this.querySelector('.product-gallery__arrow--prev');
        this.nextBtn = this.querySelector('.product-gallery__arrow--next');
        this.counter = this.querySelector('.product-gallery__counter');
        this.lightbox = this.querySelector('#gallery-lightbox');
        
        if (!this.slidesContainer || this.slides.length === 0) return;

        this.initialized = true;
        this.currentIndex = 0;
        this.isScrolling = false;

        // Sync currentIndex with whichever slide is active on load
        this.slides.forEach((slide, idx) => {
          if (slide.classList.contains('is-active')) {
            this.currentIndex = idx;
          }
        });

        // Desktop thumbnail hover & clicks
        this.thumbnails.forEach((thumb) => {
          thumb.addEventListener('mouseenter', () => this.onThumbnailTrigger(thumb));
          thumb.addEventListener('click', (e) => {
            e.preventDefault();
            this.onThumbnailTrigger(thumb);
          });
          thumb.addEventListener('keydown', (e) => this.handleKeyDown(e));
        });

        // Mobile arrows
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.navigate(-1));
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => this.navigate(1));
        }

        // Mobile scroll handler to update counter and hydrate slides
        if (this.slidesContainer) {
          this.slidesContainer.addEventListener('touchstart', () => this.hydrateAllSlides(), { once: true, passive: true });
          this.slidesContainer.addEventListener('scroll', () => {
            this.hydrateAllSlides();
            this.onScroll();
          }, { passive: true });
        }

        // Zoom functionality
        this.zoomContainers = this.querySelectorAll('.product-gallery__zoom-container');
        this.zoomContainers.forEach((container) => {
          container.addEventListener('mousemove', (e) => this.handleZoom(e, container));
          container.addEventListener('mouseleave', () => this.resetZoom(container));
          
          // Click on image handler (mobile opens lightbox zoom, desktop toggles double zoom)
          const img = container.querySelector('.product-gallery__main-image');
          if (img) {
            img.addEventListener('click', (e) => {
              if (window.matchMedia('(max-width: 991px)').matches) {
                e.preventDefault();
                const slide = img.closest('.product-gallery__slide');
                this.openLightbox(slide ? parseInt(slide.dataset.index, 10) : this.currentIndex);
              } else {
                e.preventDefault();
                container.classList.toggle('is-double-zoomed');
                this.handleZoom(e, container);
              }
            });
          }
        });

        // Mobile zoom button click
        const mobileZoomBtn = this.querySelector('.product-gallery__mobile-zoom-btn');
        if (mobileZoomBtn) {
          mobileZoomBtn.addEventListener('click', () => this.openLightbox(this.currentIndex));
        }

        // Lightbox close
        if (this.lightbox) {
          const closeBtn = this.lightbox.querySelector('.product-gallery__lightbox-close');
          if (closeBtn) {
            closeBtn.addEventListener('click', () => this.lightbox.close());
          }
          // Close on backdrop click
          this.lightbox.addEventListener('click', (e) => {
            if (e.target === this.lightbox) {
              this.lightbox.close();
            }
          });
          this.initLightboxGestures();
        }

        this.updateCounter();
      }

      hydrateImage(img) {
        if (!img) return;
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
          delete img.dataset.srcset;
        }
        if (img.dataset.src) {
          img.src = img.dataset.src;
          delete img.dataset.src;
        }
      }

      hydrateSlide(index) {
        const slide = this.slides?.[index];
        if (!slide) return;
        this.hydrateImage(slide.querySelector('img[data-src]'));
      }

      hydrateAllSlides() {
        this.slidesContainer?.querySelectorAll('img[data-src]').forEach((img) => this.hydrateImage(img));
      }

      onThumbnailTrigger(thumb) {
        const index = parseInt(thumb.dataset.index, 10);
        this.hydrateSlide(index);
        this.setActiveIndex(index);
      }

      setActiveIndex(index) {
        if (index < 0 || index >= this.slides.length || index === this.currentIndex) return;
        this.hydrateSlide(index);

        // Desktop behavior: toggle .is-active class
        this.slides[this.currentIndex].classList.remove('is-active');
        this.slides[index].classList.add('is-active');

        // Update thumbnails
        if (this.thumbnails[this.currentIndex]) {
          this.thumbnails[this.currentIndex].classList.remove('is-active');
          this.thumbnails[this.currentIndex].setAttribute('aria-selected', 'false');
        }
        if (this.thumbnails[index]) {
          this.thumbnails[index].classList.add('is-active');
          this.thumbnails[index].setAttribute('aria-selected', 'true');
          this.thumbnails[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }

        // Mobile behavior: scroll container if we are on mobile
        if (window.matchMedia('(max-width: 991px)').matches) {
          this.isScrolling = true;
          const scrollTarget = index * this.slidesContainer.clientWidth;
          this.slidesContainer.scrollTo({
            left: scrollTarget,
            behavior: 'smooth'
          });
          // Release lock after scroll completes
          setTimeout(() => { this.isScrolling = false; }, 300);
        }

        this.currentIndex = index;
        this.updateCounter();
      }

      navigate(direction) {
        let newIndex = this.currentIndex + direction;
        if (newIndex < 0) newIndex = this.slides.length - 1;
        if (newIndex >= this.slides.length) newIndex = 0;
        this.setActiveIndex(newIndex);
      }

      onScroll() {
        if (!window.matchMedia('(max-width: 991px)').matches) return;
        if (this.isScrolling) return;

        const width = this.slidesContainer.clientWidth || 1;
        const scrollLeft = this.slidesContainer.scrollLeft;
        const index = Math.round(scrollLeft / width);

        if (index !== this.currentIndex && index >= 0 && index < this.slides.length) {
          // Sync current index
          this.slides[this.currentIndex].classList.remove('is-active');
          this.slides[index].classList.add('is-active');

          if (this.thumbnails[this.currentIndex]) {
            this.thumbnails[this.currentIndex].classList.remove('is-active');
            this.thumbnails[this.currentIndex].setAttribute('aria-selected', 'false');
          }
          if (this.thumbnails[index]) {
            this.thumbnails[index].classList.add('is-active');
            this.thumbnails[index].setAttribute('aria-selected', 'true');
          }

          this.currentIndex = index;
          this.updateCounter();
        }
      }

      updateCounter() {
        if (this.counter) {
          this.counter.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
        }
        this.updateArrows();
      }

      updateArrows() {
        if (this.prevBtn) {
          if (this.currentIndex === 0) {
            this.prevBtn.setAttribute('disabled', '');
          } else {
            this.prevBtn.removeAttribute('disabled');
          }
        }
        if (this.nextBtn) {
          if (this.currentIndex === this.slides.length - 1) {
            this.nextBtn.setAttribute('disabled', '');
          } else {
            this.nextBtn.removeAttribute('disabled');
          }
        }
      }

      handleKeyDown(e) {
        const active = document.activeElement;
        if (!active || !active.classList.contains('product-gallery__thumbnail')) return;

        const index = Array.from(this.thumbnails).indexOf(active);
        let nextIndex;

        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          nextIndex = index - 1 >= 0 ? index - 1 : this.thumbnails.length - 1;
        } else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          nextIndex = index + 1 < this.thumbnails.length ? index + 1 : 0;
        }

        if (nextIndex !== undefined) {
          e.preventDefault();
          const nextThumb = this.thumbnails[nextIndex];
          nextThumb.focus();
          this.setActiveIndex(nextIndex);
        }
      }

      handleZoom(e, container) {
        // Desktop zoom only
        if (window.matchMedia('(min-width: 992px)').matches) {
          const rect = container.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;

          const img = container.querySelector('.product-gallery__main-image');
          if (img) {
            const scale = container.classList.contains('is-double-zoomed') ? 'scale(4)' : 'scale(2)';
            img.style.transformOrigin = `${x}% ${y}%`;
            img.style.transform = scale;
          }
        }
      }

      resetZoom(container) {
        container.classList.remove('is-double-zoomed');
        const img = container.querySelector('.product-gallery__main-image');
        if (img) {
          img.style.transformOrigin = 'center';
          img.style.transform = 'scale(1)';
        }
      }

      openLightbox(index = 0) {
        if (!this.lightbox || !this.lightboxTrack) return;
        this.lightbox.querySelectorAll('img[data-src]').forEach((img) => this.hydrateImage(img));
        this.lightbox.showModal();
        this.resetLightboxZoom(false);
        this.lightboxIndex = index;
        this.lightboxTrack.scrollTo({ left: index * this.lightboxTrack.clientWidth, behavior: 'instant' });
        this.updateLightboxCounter();
      }

      // --- Lightbox: swipe (native scroll snap) + pinch / double-tap zoom with panning ---
      initLightboxGestures() {
        this.lightboxTrack = this.lightbox.querySelector('.product-gallery__lightbox-track');
        this.lightboxCounter = this.lightbox.querySelector('.product-gallery__lightbox-counter');
        this.lightboxImages = this.lightbox.querySelectorAll('.product-gallery__lightbox-image');
        if (!this.lightboxTrack) return;

        this.lightboxIndex = 0;
        this.zoom = { scale: 1, x: 0, y: 0 };
        this.gesture = null;
        this.lastTap = { time: 0, x: 0, y: 0 };
        const MAX_SCALE = 4;
        const DOUBLE_TAP_SCALE = 2.5;

        const track = this.lightboxTrack;
        const distance = (a, b) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        const midpoint = (a, b) => ({ x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 });

        track.addEventListener('scroll', () => {
          if (this.zoom.scale > 1) return;
          const index = Math.round(track.scrollLeft / (track.clientWidth || 1));
          if (index !== this.lightboxIndex) {
            this.lightboxIndex = index;
            this.updateLightboxCounter();
            // The page gallery follows behind the dialog, so it shows the same image on close
            this.setActiveIndex(index);
          }
        }, { passive: true });

        track.addEventListener('touchstart', (e) => {
          const img = this.lightboxImages[this.lightboxIndex];
          if (!img) return;
          img.classList.remove('is-settling');
          if (!this.zoomBase) this.zoomBase = img.getBoundingClientRect();

          if (e.touches.length === 2) {
            const m = midpoint(e.touches[0], e.touches[1]);
            this.gesture = {
              type: 'pinch',
              startDistance: distance(e.touches[0], e.touches[1]),
              startScale: this.zoom.scale,
              // image point under the fingers, in unzoomed coordinates relative to its center
              anchorX: (m.x - this.zoomCenter().x - this.zoom.x) / this.zoom.scale,
              anchorY: (m.y - this.zoomCenter().y - this.zoom.y) / this.zoom.scale
            };
          } else if (e.touches.length === 1 && this.zoom.scale > 1) {
            this.gesture = {
              type: 'pan',
              startX: e.touches[0].clientX - this.zoom.x,
              startY: e.touches[0].clientY - this.zoom.y
            };
          }
        }, { passive: true });

        track.addEventListener('touchmove', (e) => {
          if (!this.gesture) return;
          if (this.gesture.type === 'pinch' && e.touches.length === 2) {
            e.preventDefault();
            const g = this.gesture;
            const m = midpoint(e.touches[0], e.touches[1]);
            const scale = Math.min(Math.max(g.startScale * distance(e.touches[0], e.touches[1]) / g.startDistance, 0.8), MAX_SCALE);
            const c = this.zoomCenter();
            this.zoom = { scale, x: m.x - c.x - scale * g.anchorX, y: m.y - c.y - scale * g.anchorY };
            this.applyLightboxZoom();
          } else if (this.gesture.type === 'pan' && e.touches.length === 1) {
            e.preventDefault();
            this.zoom.x = e.touches[0].clientX - this.gesture.startX;
            this.zoom.y = e.touches[0].clientY - this.gesture.startY;
            this.clampLightboxZoom();
            this.applyLightboxZoom();
          }
        }, { passive: false });

        track.addEventListener('touchend', (e) => {
          // One finger left after pinching: continue as a pan
          if (e.touches.length === 1 && this.zoom.scale > 1) {
            this.gesture = {
              type: 'pan',
              startX: e.touches[0].clientX - this.zoom.x,
              startY: e.touches[0].clientY - this.zoom.y
            };
            return;
          }
          if (e.touches.length > 0) return;

          const wasGesture = this.gesture;
          this.gesture = null;
          if (this.zoom.scale < 1.05) {
            this.resetLightboxZoom(true);
          } else {
            this.clampLightboxZoom();
            this.settleLightboxZoom();
          }

          // Double tap: zoom in at the tapped point, or back out
          const touch = e.changedTouches[0];
          if (!touch || (wasGesture && wasGesture.type === 'pinch')) return;
          const now = Date.now();
          const isDoubleTap = now - this.lastTap.time < 300 &&
            Math.hypot(touch.clientX - this.lastTap.x, touch.clientY - this.lastTap.y) < 30;
          this.lastTap = { time: isDoubleTap ? 0 : now, x: touch.clientX, y: touch.clientY };
          if (!isDoubleTap) return;

          if (this.zoom.scale > 1) {
            this.resetLightboxZoom(true);
          } else {
            const img = this.lightboxImages[this.lightboxIndex];
            if (!img) return;
            this.zoomBase = img.getBoundingClientRect();
            const c = this.zoomCenter();
            const scale = DOUBLE_TAP_SCALE;
            this.zoom = { scale, x: (1 - scale) * (touch.clientX - c.x), y: (1 - scale) * (touch.clientY - c.y) };
            this.clampLightboxZoom();
            this.settleLightboxZoom();
          }
        });

        // Keyboard: arrows switch images (when not zoomed)
        this.lightbox.addEventListener('keydown', (e) => {
          if (this.zoom.scale > 1 || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
          e.preventDefault();
          const next = Math.min(Math.max(this.lightboxIndex + (e.key === 'ArrowRight' ? 1 : -1), 0), this.lightboxImages.length - 1);
          track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
        });

        // Closing (button, Escape, backdrop): drop the zoom
        this.lightbox.addEventListener('close', () => this.resetLightboxZoom(false));
      }

      zoomCenter() {
        const r = this.zoomBase;
        return r ? { x: r.left + r.width / 2, y: r.top + r.height / 2 } : { x: 0, y: 0 };
      }

      // Keep the zoomed image covering the screen: no empty gaps at the edges
      clampLightboxZoom() {
        const r = this.zoomBase;
        if (!r) return;
        const maxX = Math.max(0, (r.width * this.zoom.scale - window.innerWidth) / 2);
        const maxY = Math.max(0, (r.height * this.zoom.scale - window.innerHeight) / 2);
        const c = this.zoomCenter();
        // offsets are relative to the image center; keep the image centered on screen
        const centerShiftX = window.innerWidth / 2 - c.x;
        const centerShiftY = window.innerHeight / 2 - c.y;
        this.zoom.x = Math.min(Math.max(this.zoom.x, centerShiftX - maxX), centerShiftX + maxX);
        this.zoom.y = Math.min(Math.max(this.zoom.y, centerShiftY - maxY), centerShiftY + maxY);
      }

      applyLightboxZoom() {
        const img = this.lightboxImages && this.lightboxImages[this.lightboxIndex];
        if (!img) return;
        const { scale, x, y } = this.zoom;
        img.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
        this.lightbox.classList.toggle('is-zoomed', scale > 1);
      }

      settleLightboxZoom() {
        const img = this.lightboxImages && this.lightboxImages[this.lightboxIndex];
        if (img) img.classList.add('is-settling');
        this.applyLightboxZoom();
      }

      resetLightboxZoom(animate) {
        this.zoom = { scale: 1, x: 0, y: 0 };
        this.zoomBase = null;
        (this.lightboxImages || []).forEach((img) => {
          img.classList.toggle('is-settling', animate);
          img.style.transform = '';
        });
        if (this.lightbox) this.lightbox.classList.remove('is-zoomed');
      }

      updateLightboxCounter() {
        if (this.lightboxCounter) {
          this.lightboxCounter.textContent = `${this.lightboxIndex + 1} / ${this.lightboxImages.length}`;
        }
      }
    }
    customElements.define('product-gallery', ProductGallery);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const productForm = document.getElementById('product-form-installment');
    const submitBtn = productForm ? productForm.querySelector('.product-detail__cart-submit') : null;

    const syncProductCartButton = () => {
      if (!submitBtn) return;

      const selectEl = document.querySelector('select[name="id"]');
      if (!selectEl) return;
      const variantId = parseInt(selectEl.value, 10);
      // No size chosen yet: keep the button active, native `required` validation prompts on submit
      const hasSelection = !Number.isNaN(variantId);

      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const cartVariantIds = cart.items.map(item => item.variant_id);
          if (hasSelection && cartVariantIds.includes(variantId)) {
            submitBtn.disabled = true;
            submitBtn.style.opacity = '0.5';
            submitBtn.innerHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" style="width: 20px; height: 20px; vertical-align: middle; margin-right: 8px; display: inline-block;">
                <path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"/>
              </svg>
              ${submitBtn.dataset.labelInCart}
            `;
          } else {
            // Restore default form button state based on variant availability
            const selectedOption = selectEl.options[selectEl.selectedIndex];
            const isAvailable = !hasSelection || (selectedOption ? !selectedOption.disabled : true);

            if (isAvailable) {
              submitBtn.disabled = false;
              submitBtn.style.opacity = '';
              submitBtn.innerHTML = `
                <span class="btn__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" style="width: 20px; height: 20px; vertical-align: middle; display: inline-block; margin-right: 8px;">
                    <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM176,88a48,48,0,0,1-96,0,8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0Z"/>
                  </svg>
                </span>
                <span class="btn__text">${submitBtn.dataset.labelAdd}</span>
              `;
            } else {
              submitBtn.disabled = true;
              submitBtn.style.opacity = '0.5';
              submitBtn.innerHTML = `<span class="btn__text">${submitBtn.dataset.labelSoldOut}</span>`;
            }
          }
        })
        .catch(err => console.error('Error syncing product cart button:', err));
    };

    if (productForm && submitBtn) {
      productForm.addEventListener('submit', (event) => {
        event.preventDefault();

        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.7';

        const formData = new FormData(productForm);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          // Success feedback
          // Update the cart drawer and header
          if (typeof window.refreshCartDrawerAndHeader === 'function') {
            window.refreshCartDrawerAndHeader();
          }

          // Permanently set to success state and disable
          submitBtn.disabled = true;
          submitBtn.style.opacity = '0.5';
          submitBtn.innerHTML = `
            <svg data-animate xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true" style="width: 20px; height: 20px; vertical-align: middle; margin-right: 8px; display: inline-block;">
              <path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"/>
            </svg>
            ${submitBtn.dataset.labelInCart}
          `;
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          submitBtn.disabled = false;
          submitBtn.style.opacity = '';
        });
      });

      // Synchronize on cart updates
      document.addEventListener('cart:updated', syncProductCartButton);

      // Listen for select changes on variants to update button state, price and stock note
      const variantSelect = productForm.querySelector('select[name="id"]');
      if (variantSelect) {
        const priceEl = document.querySelector('[data-product-price]');
        const comparePriceEl = document.querySelector('[data-product-compare-price]');
        const stockNote = productForm.querySelector('[data-stock-note]');

        const updateVariantDetails = () => {
          const option = variantSelect.options[variantSelect.selectedIndex];
          if (!option || !option.value) return;

          const { price, comparePrice, stockText } = option.dataset;
          if (priceEl && price) {
            priceEl.textContent = price;
            priceEl.classList.toggle('product-detail__price--sale', Boolean(comparePrice));
          }
          if (comparePriceEl) {
            comparePriceEl.textContent = comparePrice || '';
            comparePriceEl.hidden = !comparePrice;
          }
          if (stockNote) {
            stockNote.textContent = stockText || '';
            stockNote.hidden = !stockText;
          }
        };

        // :user-invalid only styles the field; keep aria-invalid in sync for screen readers
        const syncAriaInvalid = () => {
          if (variantSelect.checkValidity()) {
            variantSelect.removeAttribute('aria-invalid');
          } else {
            variantSelect.setAttribute('aria-invalid', 'true');
          }
        };

        variantSelect.addEventListener('change', () => {
          updateVariantDetails();
          syncAriaInvalid();
          syncProductCartButton();
        });
        variantSelect.addEventListener('invalid', syncAriaInvalid);
      }

      // Initial sync on load
      syncProductCartButton();
    }

    // Wishlist Toggle Handling for PDP
    // The product card script binds every [data-wishlist-toggle] on the page as well;
    // the shared jsBound flag makes sure only one click handler toggles the item
    const wishlistBtn = document.querySelector('.product-gallery__wishlist-btn[data-wishlist-toggle]');
    if (wishlistBtn && !wishlistBtn.dataset.jsBound) {
      wishlistBtn.dataset.jsBound = 'true';
      const handle = wishlistBtn.getAttribute('data-wishlist-toggle');
      try {
        const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
        if (Array.isArray(wishlist)) {
          const isActive = wishlist.includes(handle);
          wishlistBtn.classList.toggle('is-active', isActive);
          wishlistBtn.setAttribute('aria-pressed', String(isActive));
        }
      } catch (e) {
        console.error('Error reading wishlist on load:', e);
      }

      wishlistBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
          let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
          if (!Array.isArray(wishlist)) wishlist = [];
          if (wishlist.includes(handle)) {
            wishlist = wishlist.filter(item => item !== handle);
            wishlistBtn.classList.remove('is-active');
            wishlistBtn.setAttribute('aria-pressed', 'false');
          } else {
            wishlist.push(handle);
            wishlistBtn.dataset.animate = '';
            wishlistBtn.classList.add('is-active');
            wishlistBtn.setAttribute('aria-pressed', 'true');
          }
          localStorage.setItem('wishlist', JSON.stringify(wishlist));
          document.dispatchEvent(new CustomEvent('wishlist:updated'));
        } catch (err) {
          console.error('Error toggling wishlist:', err);
        }
      });
    }

    // Size Guide Modal - Open, Auto-scroll & Backdrop Close
    const sizeDialog = document.getElementById('size-dialog');

    const scrollToCurrentSize = () => {
      if (!sizeDialog) return;
      const currentRow = sizeDialog.querySelector('.pdp-modal__row--current');
      if (currentRow) {
        currentRow.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    };

    window.openSizeGuideModal = () => {
      if (!sizeDialog) return;
      if (typeof sizeDialog.showModal === 'function') {
        sizeDialog.showModal();
      } else {
        sizeDialog.setAttribute('open', '');
      }
      setTimeout(scrollToCurrentSize, 100);
    };

    if (sizeDialog) {
      // Close on backdrop click
      sizeDialog.addEventListener('click', (event) => {
        if (event.target === sizeDialog) {
          sizeDialog.close();
        }
      });

      // Also trigger auto-scroll if opened via any other method
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (sizeDialog.hasAttribute('open')) {
              setTimeout(scrollToCurrentSize, 100);
            }
          }
        });
      });
      observer.observe(sizeDialog, { attributes: true });
    }

    // Attach to any size guide triggers on the page
    const sizeGuideTriggers = document.querySelectorAll('.js-size-guide-trigger');
    sizeGuideTriggers.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        window.openSizeGuideModal();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const track = document.querySelector('.js-size-nav-track');
    const prevBtn = document.querySelector('.js-size-nav-prev');
    const nextBtn = document.querySelector('.js-size-nav-next');
    const controls = document.querySelector('.size-nav__controls');

    if (track && prevBtn && nextBtn && controls) {
      const updateControls = () => {
        const hasOverflow = track.scrollWidth > track.clientWidth + 4;
        controls.style.display = hasOverflow ? 'flex' : 'none';

        if (hasOverflow) {
          const atStart = track.scrollLeft <= 5;
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
          prevBtn.disabled = atStart;
          nextBtn.disabled = atEnd;
          prevBtn.style.opacity = atStart ? '0.3' : '1';
          prevBtn.style.cursor = atStart ? 'default' : 'pointer';
          nextBtn.style.opacity = atEnd ? '0.3' : '1';
          nextBtn.style.cursor = atEnd ? 'default' : 'pointer';
        }
      };

      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -260, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: 260, behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
      setTimeout(updateControls, 100);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-info"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('map-consent')) {
    customElements.define(
      'map-consent',
      class MapConsent extends HTMLElement {
        connectedCallback() {
          this.querySelector('.store-info__map-button')?.addEventListener('click', () => this.load(), { once: true });
        }

        load() {
          const iframe = document.createElement('iframe');
          iframe.src = this.dataset.src;
          iframe.title = this.dataset.title;
          iframe.loading = 'lazy';
          iframe.referrerPolicy = 'no-referrer-when-downgrade';
          iframe.allowFullscreen = true;
          iframe.className = 'store-info__iframe';
          this.replaceChildren(iframe);
          iframe.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  if (!customElements.get('wishlist-grid')) {
    customElements.define('wishlist-grid', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-wishlist-grid]');
        this.emptyEl = this.querySelector('[data-wishlist-empty]');
        this.loadingEl = this.querySelector('[data-wishlist-loading]');
        this.headerEl = this.querySelector('[data-wishlist-header]');
        this.actionsEl = this.querySelector('[data-wishlist-actions]');
        this.countEl = this.querySelector('[data-wishlist-count]');
        this.deleteSoldBtn = this.querySelector('[data-wishlist-delete-sold]');
        this.feedbackEl = this.querySelector('[data-wishlist-feedback]');

        this.sectionId = this.dataset.sectionId;
        this.rootUrl = (this.dataset.rootUrl || '/').replace(/\/$/, '');

        this.deleteSoldBtn?.addEventListener('click', () => this.deleteSoldItems());

        this.onWishlistUpdated = () => this.syncWithStorage();
        document.addEventListener('wishlist:updated', this.onWishlistUpdated);

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.load(), { once: true });
        } else {
          this.load();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('wishlist:updated', this.onWishlistUpdated);
      }

      readHandles() {
        try {
          const list = JSON.parse(localStorage.getItem('wishlist') || '[]');
          return Array.isArray(list) ? list : [];
        } catch (e) {
          console.error('Error reading wishlist from localStorage:', e);
          return [];
        }
      }

      updateCount(count) {
        if (!this.countEl) return;
        const template = count === 1 ? this.dataset.textCountOne : this.dataset.textCountOther;
        // Liquid renders the locale string with "[count]" as placeholder
        const text = (template || '[count]').replace('[count]', count);
        this.countEl.textContent = text;
      }

      updateDeleteSoldBtnState() {
        if (!this.deleteSoldBtn) return;
        const soldCards = this.getSoldCards();
        // Only offered when there is something to delete
        this.deleteSoldBtn.hidden = soldCards.length === 0;
      }

      getSoldCards() {
        if (!this.grid) return [];
        return Array.from(this.grid.querySelectorAll('.collection-product')).filter((card) => {
          return card.dataset.productAvailable === 'false' || card.querySelector('.collection-product__sold-badge');
        });
      }

      deleteSoldItems() {
        const soldCards = this.getSoldCards();
        if (soldCards.length === 0) {
          this.showFeedback(this.dataset.textNoSold || '');
          return;
        }

        const soldHandles = soldCards
          .map((card) => card.dataset.productHandle)
          .filter(Boolean);

        const remaining = this.readHandles().filter((h) => !soldHandles.includes(h));
        try {
          localStorage.setItem('wishlist', JSON.stringify(remaining));
        } catch (e) {
          console.error('Error updating wishlist in localStorage:', e);
        }

        soldCards.forEach((card) => card.remove());

        this.showFeedback(this.dataset.textSoldRemoved || '');
        document.dispatchEvent(new CustomEvent('wishlist:updated'));
        this.updateCount(this.grid.children.length);
        this.updateDeleteSoldBtnState();

        if (this.grid.children.length === 0) {
          this.showEmpty();
        }
      }

      showFeedback(message) {
        if (!this.feedbackEl || !message) return;
        this.feedbackEl.textContent = message;
        clearTimeout(this._feedbackTimer);
        this._feedbackTimer = setTimeout(() => {
          this.feedbackEl.textContent = '';
        }, 3000);
      }

      async load() {
        const handles = this.readHandles();
        if (handles.length === 0) {
          this.showEmpty();
          return;
        }

        const staleHandles = [];
        const cards = await Promise.all(handles.map(async (handle) => {
          try {
            const url = `${this.rootUrl}/products/${encodeURIComponent(handle)}?section_id=${this.sectionId}`;
            const res = await fetch(url);
            if (res.status === 404) {
              staleHandles.push(handle);
              return null;
            }
            if (!res.ok) return null;
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const card = doc.querySelector('.collection-product');
            if (!card) {
              staleHandles.push(handle);
              return null;
            }
            return card;
          } catch (e) {
            console.error(`Error loading wishlist product "${handle}":`, e);
            return null;
          }
        }));

        cards.forEach((card) => {
          if (card) this.grid.appendChild(card);
        });

        if (staleHandles.length > 0) this.removeFromStorage(staleHandles);

        this.loadingEl.hidden = true;
        if (this.grid.children.length > 0) {
          this.headerEl.hidden = false;
          this.actionsEl.hidden = false;
          this.grid.hidden = false;
          this.updateCount(this.grid.children.length);
          this.updateDeleteSoldBtnState();
          document.dispatchEvent(new CustomEvent('product-cards:added'));
        } else {
          this.showEmpty();
        }
      }

      showEmpty() {
        this.loadingEl.hidden = true;
        this.grid.hidden = true;
        this.headerEl.hidden = true;
        this.actionsEl.hidden = true;
        this.emptyEl.hidden = false;
      }

      removeFromStorage(handles) {
        try {
          const remaining = this.readHandles().filter((h) => !handles.includes(h));
          localStorage.setItem('wishlist', JSON.stringify(remaining));
          document.dispatchEvent(new CustomEvent('wishlist:updated'));
        } catch (e) {
          console.error('Error updating wishlist in localStorage:', e);
        }
      }

      syncWithStorage() {
        const handles = this.readHandles();
        this.grid.querySelectorAll('.collection-product').forEach((card) => {
          if (!handles.includes(card.dataset.productHandle)) card.remove();
        });
        if (!this.loadingEl.hidden) return;
        this.updateCount(this.grid.children.length);
        this.updateDeleteSoldBtnState();
        if (this.grid.children.length === 0) this.showEmpty();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
